/**
 * FileName : http.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-03 22:34:16
 * Description :
 * -----
 * Last Modified: 2024-11-26 08:54:07
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import axios from 'axios';
// import qs from 'qs';
// import { showLoading, hideLoading } from 'src/components/common/loding';
import { store } from 'src/store/index';
import { message } from 'antd';
import { CLEAR_LOGIN } from 'src/store/common/user';
import {COLLAPSED_TOGGLE} from 'src/store/common/collapsed';

// const pending = new Map();
const Axios = axios.create({
    baseURL: window?.config?.baseURL || '/', // 设置请求的base url /wasion-overseas-mdr-dist
    timeout: 3600000, // 设置超时时长
    withCredentials: false,
});
// 请求获取下载流
const AxiosBlob = axios.create({
    baseURL: window?.config?.baseURL || '/', // 设置请求的base url /wasion-overseas-mdr-dist
    timeout: 3600000, // 设置超时时长
    withCredentials: false,
    responseType: 'blob',
});

const JSONAxios = axios.create({
    timeout: 3600000, // 设置超时时长
    withCredentials: false,
});
// const CancelToken = axios.CancelToken;

// const cancelAxios = (url: string) => { // 取消请求
//     if (pending.has(url)) {
//         pending.get(url).func();
//         pending.delete(url);
//     }
// };

Axios.interceptors.request.use((config:any) => {
    // showLoading();
    config.headers.version = '2.0';
    config.headers.username = store.getState()?.userInfo?.sysUser?.username || '';
    // if (config.url && pending.has(config.url)) { // 是否已经在请求
    //     cancelAxios(config.url as string); // 取消请求
    // } else { // 添加进入请求队列
    //     config.cancelToken = new CancelToken((c) => pending.set(config.url, { func: c }));
    // }
    return Promise.resolve(config);
},
(error:any) => {
    Promise.reject(error);
});

// eslint-disable-next-line complexity
Axios.interceptors.response.use((res:any) => {
    // cancelAxios(res.config.url as string); // 请求完成，取消请求
    if (res.status >= 500) {
        // location.href = '/500';
        return Promise.reject('');
    }
    if (res.status >= 502 && !sessionStorage.getItem('httpState')) {
        sessionStorage.setItem('httpState', '1');
        location.href = '/502';
        return Promise.reject('');
    }
    if (res.status === 400) {
        const Mes = store.getState()?.langSwitch.message || {};

        return Promise.reject(Mes['messageParamsVerifyFails']);
    }
    // code为0，请求正常且成功
    if (res.status === 200 && typeof res.data.code === 'number' && !res.data.code) {
        return Promise.resolve(res.data.data);
    }
    // 1002密码失效，1005密码需要重置，1006账号密码被修改需要重新登录

    if (res.status === 200 && typeof res.data.code === 'number' && res.data.code === 1006) {
        console.info(`${new Date()}----退出-----${res.data.code}`);
        const Mes = store.getState()?.langSwitch.message || {};

        if (sessionStorage.getItem('httpState') !== '2') { // 批次多次请求多次弹窗与用户数据初始化的问题。
            message.error(Mes['messageTitleLoginExpired']);
            sessionStorage.setItem('httpState', '2');
            store.dispatch({
                type: CLEAR_LOGIN,
            });
            store.dispatch({
                type: COLLAPSED_TOGGLE,
                value: true,
            });
        }
        // location.href = '/login';
        return Promise.reject('');
    }
    if (sessionStorage.getItem('httpState')) { // 正常返回后，将状态设置为解锁
        sessionStorage.setItem('httpState', '');
    }
    if (res.status === 200 && typeof res.data.code === 'number' && (res.data.code === 1005 || res.data.code === 1002)) {
        return Promise.resolve({code: res.data.code});
    }
    if (res.status === 200 && (res.config.url?.includes('excelUpload') || res.config.url?.includes('upgradeFolderUpload') || res.config.url?.includes('download'))) { // 上传成功时没有code返回。针对上传特殊处理
        return Promise.resolve(res.data);
    }
    return Promise.reject(res.data.message ? res.data.message : 'Request Failure!');
},
(error:any) => {
    console.error('Axios-error', error);
    if (error.toString().includes('400')) {
        const Mes = store.getState()?.langSwitch.message || {};

        return Promise.reject(Mes['messageParamsVerifyFails']);
    }
    if (error.toString().includes('500')) {
        const Mes = store.getState()?.langSwitch.message || {};

        return Promise.reject(Mes['menuTitleServiceExcep']);
    }
    if ((error.toString().includes('502') || error.toString().includes('504')) && !sessionStorage.getItem('httpState')) {
        const Mes = store.getState()?.langSwitch.message || {};

        sessionStorage.setItem('httpState', '1');
        location.href = '/502';
        return Promise.reject(Mes['messageSystemMaintenance']);
    }
    // location.href = '/500';
    return Promise.reject(error.toString());
});
// eslint-disable-next-line complexity
AxiosBlob.interceptors.response.use((res:any) => {
    // cancelAxios(res.config.url as string); // 请求完成，取消请求
    if (res.status >= 500) {
        // location.href = '/500';
        return Promise.reject('');
    }
    if (res.status >= 502 && !sessionStorage.getItem('httpState')) {
        location.href = '/502';
        return Promise.reject('');
    }
    if (res.status === 400) {
        const Mes = store.getState()?.langSwitch.message || {};

        return Promise.reject(Mes['messageParamsVerifyFails']);
    }

    if (res.status === 200) {
        return Promise.resolve(res.data);
    }
    return Promise.reject(res.data.message ? res.data.message : 'Request Failure!');
},
(error:any) => {
    console.error('Axios-error', error);
    // location.href = '/500';
    return Promise.reject(error.toString());
});

export type UploadResult = {
    hintMsg: string;
    TotalSize: number;
    Status: string;
    fileId: string;
}

export type JSONGetParams = {
    url: string,
    config?: any;
  }

const get = <T extends unknown = any>(url: string = '', params = {}): Promise<T> => Axios.get(url, {params: params});

const post = <T extends unknown = any> (url: string = '', data = {}): Promise<T> => Axios.post(url, data);

const blobPost = <T extends unknown = any> (url: string = '', data = {}): Promise<T> => AxiosBlob.post(url, data);
const jsonGet = <T extends unknown = any>(params:JSONGetParams): Promise<T> => JSONAxios.get(params.url, {...params.config});

const excelUpload = (data: FormData, url:string = '/excelUpload'): Promise<UploadResult> => Axios.post(url, data);
const upgradeFolderUpload = (data: FormData): Promise<any> => Axios.post('/upgradeFolderUpload', data);

export {
    get,
    post,
    excelUpload,
    upgradeFolderUpload,
    blobPost,
    jsonGet,
};

export default Axios;
